import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-messageerror',
  templateUrl: './messageerror.component.html',
  styleUrls: ['./messageerror.component.css']
})
export class MessageerrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
